export const MenuOptions = {
    serviceDescription: 1,
    details: 2,
    claims: 3,
    payment: 4,
    messages: 5,
    actionRequired: 6,

    requiredForm: 10
}